import { useCallback } from 'react';
import speak from '@shared/utils/speak';
import { VOICED_MESSAGE_PRIORITY } from '@shared/constants';
import useManuallyTriggeredAudio from '@shared/hooks/useManuallyTriggeredAudio';

export default function useVoicedMessage(message: string) {
  const voiceMessage = useCallback(async () => {
    await speak(message);
  }, [message]);

  useManuallyTriggeredAudio(VOICED_MESSAGE_PRIORITY, voiceMessage);
}
